<template>
<article-layout>
    <div class="subpage-top">
        <h1>Over ons</h1>
        <router-link to="/#about">Terug</router-link>
    </div>
    <p>
        De vzw "De Belgische Mastiff" is opgericht in 2006 om het herfokken van de uitgestorven Belgische Mastiff duidelijk te structureren
        en in kaart te brengen. De vzw zette op die manier het buikgevoel dat eind jaren '90 bij Fons Bertels is ontstaan om in een werkwijze 
        met meer duidelijkheid en openheid. In het begin gebeurde dit enkel binnen de vzw zelf samen met enthousiaste liefhebbers, maar
        de afgelopen jaren is er een nauwe samenwerking ontstaan tussen de vzw en de KMSH. Zowel de KMSH als de wetenschappelijke commissie van de KKUSH staan ons
        steeds bij in het fokprogramma. Zo wordt de volgende stap in het fokprogramma nauwkeurig bepaald en beredeneerd na overleg met alle
        betrokken instanties. Dankzij hun professionele advies zijn wij in staat om gaandeweg te evolueren naar een populatie honden die aan de
        rasstandaard voldoet.
    </p>
    <br />
    <p>
        In de 19e eeuw werd de Belgische Mastiff vooral gebruikt in zijn rol als Belgsiche trekhond. De hond diende als werkkracht bij de boer,
        maar was ook gegeerd in het leger tijdens de Eerste Wereldoorlog. Aangezien we voldoende oog willen hebben voor de rijke geschiedenis
        van het ras, toont de vzw de Belgische Mastiff af en toe als authentieke trekhond binnen een gepast historisch kader, zoals bijvoorbeeld
        in samenwerking met het Koninklijk Legermuseum en het Detachement 1914. Wij beschikken hiervoor over de nodige vergunningen van de Vlaamse
        overheid en het departement dierenwelzijn. De Belgische Mastiff van de 21e eeuw willen wij echter niet profileren als enkel een functionele
        trekhond, maar veeleer als trouwe gezins- en waakhond met een hoge aaibaarheidsfactor. Het is daarom voor ons van groot belang om
        toekomstige baasjes voldoende in te lichten over het ras zodat zij ten volle kunnen genieten van de liefde en warmte
        dat deze hond te bieden heeft. Als gevolg hiervan nodigen wij geinteresseerden in een puppy steeds uit voor een informatief gesprek.
    </p>
</article-layout>

</template>

<script>
import ArticleLayout from "./ArticleLayout";
export default {
    name: "AboutDetailed",
    components: {
        ArticleLayout
    }
}
</script>

<style scoped>
</style>